import { render } from "./FractionList.vue?vue&type=template&id=68de1cba&scoped=true"
import script from "./FractionList.vue?vue&type=script&lang=js"
export * from "./FractionList.vue?vue&type=script&lang=js"

import "./FractionList.vue?vue&type=style&index=0&id=68de1cba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68de1cba"]])

export default __exports__